<template>
    <div
        class="flex gap-3 bg-slate-100 rounded-t-xl px-4 py-4 flex-col lg:flex-row lg:px-8 lg:py-6 lg:items-center lg:justify-between"
        :class="{
            'rounded-b-xl': !expanded,
            'border-b-slate-200 border-b': expanded,
        }"
    >
        <div class="flex items-center gap-3">
            <div class="text-xl font-extrabold">
                <slot name="title"></slot>
            </div>
            <vx-badge size="xs">{{ rulesCount }}</vx-badge>
        </div>
        <div class="flex flex-col gap-3 lg:gap-4 lg:flex-row">
            <vx-toggle v-model="enabled">
                <template v-slot:no> Off </template>
                <template v-slot:yes> On </template>
            </vx-toggle>
            <vx-button @click="expanded = !expanded" color="muted-dark">
                <span class="inline-block lg:hidden">{{ expanded ? 'Collapse' : 'Expand' }}</span>
                <font-awesome-icon :icon="expanded ? faCaretUp : faCaretDown" />
            </vx-button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { VxButton, VxBadge, VxToggle } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';

defineProps<{
    rulesCount: number;
}>();

const enabled = defineModel<boolean>('enabled', { required: true });
const expanded = defineModel<boolean>('expanded', { required: true });
</script>
